import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import { ChevronDown } from 'react-feather'
import { Link } from 'react-router-dom'

import { trans, humanizeDate, ensureStartOfDay, ensureEndOfDay } from '@utils'
import HumanizeDate from "@src/components/HumanizeDate"
import LoadingIndicator from "@src/components/LoadingIndicator"
import Avatar from '@components/avatar'

import { submitAnalyticsWithFiltersAndKeys } from "../../redux/actions"
import _ from "lodash"
import Datatable from '@src/components/datatable'

const InspectionsWithLowestScoreTable = props => {
  const { toolbarDetailsComponent: ToolbarDetailsComponent, date } = props

  const data = useSelector(store => _.get(store, 'analytics.data.inspections_table'))
  const filters = useSelector(store => _.get(store, 'analytics.filters'))
  const loading = useSelector(store => _.get(store, 'app.loading'))
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(50)

  const formatUserName = (user) => {
    let name = ''
    const splittedFirstName = user?.first_name ? user.first_name?.split(' ') : ['']
    const splittedLastName = user?.last_name ? user.last_name?.split(' ') : ['']
    const firstNameSize = _.size(splittedFirstName)
    const lastNameSize = _.size(splittedLastName)
    if (firstNameSize > 0 && lastNameSize > 0) {
      name = _.join([splittedFirstName[0][0], splittedLastName[0][0]], '')
    } else if (firstNameSize >= 2) {
      name = _.join([splittedFirstName[0][0], splittedFirstName[1][0]], '')
    } else if (lastNameSize >= 2) {
      name = _.join([splittedLastName[0][0], splittedLastName[1][0]], '')
    } else {
      name = splittedFirstName[0][0] ?? splittedLastName[0][0] ?? ''
    }
    return name
  }

  const basicColumns = [
    {
      name: '#',
      cell: (row, index) => {
        return (rowsPerPage * (page - 1)) + index + 1
      },
      grow: 0,
      center: true,
      minWidth: '75px'
    },
    {
      name: trans("analytics.inspectionsTable.assignment"),
      selector: (row) => _.get(row, 'assignment.title', '-'),
      sortable: true,
      grow: 1,
      wrap: true
    },
    {
      name: trans("analytics.inspectionsTable.asset"),
      selector: (row) => _.get(row, 'asset.asset_id', '-'),
      sortable: true,
      grow: 1,
      wrap: true
    },
    {
      name: trans("analytics.inspectionsTable.checklist"),
      selector: (row) => _.get(row, 'template.title', '-'),
      sortable: true,
      grow: 1,
      wrap: true
    },
    {
      name: trans("analytics.inspectionsTable.user"),
      selector: (row) => _.get(row, 'current_user.full_name', '-'),
      sortable: true,
      grow: 0,
      wrap: true,
      cell: (row) => {
        return (
          <Avatar
            content={formatUserName(_.get(row, 'current_user'))}
            title={_.get(row, 'current_user.full_name')}
          />
        )
      }
    },
    {
      name: trans("analytics.inspectionsTable.status"),
      selector: (row) => _.get(row, 'status.label', '-'),
      sortable: true,
      grow: 0,
      minWidth: '120px',
      wrap: true
    },
    {
      name: trans("analytics.inputs.issues"),
      selector: 'count_issues',
      sortable: true,
      grow: 0,
      wrap: true
    },
    {
      name: trans("analytics.inputs.failed"),
      selector: 'count_failed',
      sortable: true,
      grow: 0,
      wrap: true
    },
    {
      name: trans("analytics.inputs.score"),
      selector: 'score',
      sortable: true,
      grow: 0,
      wrap: true
    },
    {
      name: trans("analytics.inputs.date"),
      selector: 'started_at',
      sortable: true,
      wrap: true,
      grow: 0,
      minWidth: '130px',
      format: (row, index) => {
        return (
          <HumanizeDate date={row['updated_at']} />
        )
      }
    },
    {
      name: '',
      allowOverflow: true,
      grow: 0,
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <div className="d-flex align-items">
            <Button className={'text-no-wrap'} color='secondary' outline size='sm' tag={Link} target={'_blank'} to={`/inspections/${row.uuid}/view-report`} >
              {trans('gen.actions.view')}
            </Button>
          </div>
        )
      }
    }
  ]

  useEffect(() => {
    dispatch(submitAnalyticsWithFiltersAndKeys(['inspections_table'], { ...filters, date_from: ensureStartOfDay(date.from), date_to: ensureEndOfDay(date.to) }, false))
  }, [])

  const paginationComponentOptions = {
    rowsPerPageText: trans('analytics.inspectionsTable.datatable.rowPerPage'),
    rangeSeparatorText: trans('analytics.inspectionsTable.datatable.of'),
    selectAllRowsItemText: trans('analytics.actions.all'),
    selectAllRowsItem: true
  }

  if (loading) {
    return <LoadingIndicator loading={true} />
  }

  const getData = (params, callback) => {

    callback({
      list: data,
      pagination: {
        current_page: 1,
        limit: 0,
        total: 0,
        total_pages: 0
      }
    })
  }

  if (!_.isArray(data)) {
    return null
  }

  return (
    <div className="react-dataTable-wrapper">
      {ToolbarDetailsComponent && <ToolbarDetailsComponent />}

      <Datatable
        noHeader
        striped
        _fetchData={getData}
        columns={basicColumns}
        hasFilter={false}
        clientSideMode={true}
        pagination={true}
        fixedHeader={true}
      />
      {/* <DataTable
        noHeader
        striped
        pagination
        data={data}
        columns={basicColumns}
        className='react-dataTable'
        highlightOnHover={true}
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        paginationPerPage={rowsPerPage}
        paginationComponentOptions={paginationComponentOptions}
        sortIcon={<ChevronDown size={10} />}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
      /> */}
    </div>
  )
}

InspectionsWithLowestScoreTable.propTypes = {

}

export default InspectionsWithLowestScoreTable
